export default "__VITE_ASSET__0781b9af__"